<div class="carousel-dialog">
  <div class="dialog-header">
    <h2 mat-dialog-title>{{ productName }} - {{ title }}</h2>
    <button class="close-button" (click)="onClose()" aria-label="Close">
      <span>&times;</span>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <div class="carousel-container">
      <!-- Previous Button -->
      <button
        class="carousel-nav-button prev-button"
        (click)="previousImage()"
        [disabled]="!canGoPrevious"
        aria-label="Previous image">
        &#10094;
      </button>

      <!-- Image Display -->
      <div class="image-container">
        <img
          [src]="images[currentIndex]"
          [alt]="'Image ' + currentImageNumber"
          class="carousel-image"
           />

        <!-- Image Counter -->
        <div class="image-counter">
          {{ currentImageNumber }} / {{ totalImages }}
        </div>
      </div>

      <!-- Next Button -->
      <button
        class="carousel-nav-button next-button"
        (click)="nextImage()"
        [disabled]="!canGoNext"
        aria-label="Next image">
        &#10095;
      </button>
    </div>

    <!-- Thumbnail Navigation -->
    <div class="thumbnail-container" *ngIf="totalImages > 1">
      <div
        *ngFor="let image of images; let i = index"
        class="thumbnail"
        [class.active]="i === currentIndex"
        (click)="goToImage(i)">
        <img [src]="image" [alt]="'Thumbnail ' + (i + 1)" />
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <button class="action-button" (click)="onClose()">Close</button>
  </mat-dialog-actions>
</div>
